<div class="sidebar-details tab-content">
    <div class="tab-pane fade show active" id="software-rates">
        <div class="heading">
            <h2>Software Rates</h2>
        </div>
        <div class="data">
            <div class="canvas-table">
                <form [formGroup]="softwareRatesFormGroup">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Software</th>
                                <th>Hourly Cost Rate</th>
                                <th>
                                    <button (click)="showInputSoftwareRates()" class="btn btn-icon">
                                        <span>
                                            <i class="ri-add-line"></i>
                                        </span>
                                    </button>
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let item of jsonData">
                                <td>{{item.software}}</td>
                                <td>{{item.hourlyCostRate}}</td>
                                <td>
                                    <div class="delete">
                                        <button (click)="deleteSoftwareRates(item.id)"><span><i class="ri-delete-bin-line"></i></span></button>
                                    </div>
                                </td>
                            </tr>
                            <tr *ngIf="isShowInputSoftwareRates">
                                <td>
                                    <input type="text" formControlName="software">
                                </td>
                                <td>
                                    <input type="number" formControlName="hourlyCostRate">
                                </td>
                                <td>
                                    <button class="btn" (click)="addSoftwareRates()">Save</button>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </form>
            </div>
        </div>
    </div>
</div>